module.exports = __webpack_public_path__ + "media/images/star-active-0962a53cba16cba0c1f01cb3c6a8a130.svg";